import { render, staticRenderFns } from "./LogTableTransactions.vue?vue&type=template&id=29c5f28c&"
import script from "./LogTableTransactions.vue?vue&type=script&lang=js&"
export * from "./LogTableTransactions.vue?vue&type=script&lang=js&"
import style0 from "./LogTableTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports